import StoreModule from "../core/StoreModule";
import { ApplicationState } from "./state";

class ApplicationStore extends StoreModule<ApplicationState> {
  protected state: ApplicationState = {
    application: null,
  };

  get application() {
    return this.state.application;
  }

  set application(val: ApplicationState["application"]) {
    this.setState({ application: val });
  }
}

export const $application = StoreModule.singleton(ApplicationStore);
